function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.76 0c.71.26 1.4.56 2.11.78A17.57 17.57 0 1 1 1.44 20.06 17.65 17.65 0 0 1 14.46.54c.59-.15 1.17-.36 1.75-.54zm-2.91 21.34a3.74 3.74 0 1 0-.09-7.48 3.74 3.74 0 0 0 .09 7.48zM0 42.14l3.93-7 .57.32c-1.64 3.39-1 4.84 2.77 6 8.21 2.54 16.44 5.06 24.63 7.67 5.27 1.69 9.5 4.64 10.44 10.53.77 4.79-.13 9.18-4.43 12.24 2.07-3.39 1.36-5.29-2.44-6.56-.51-.18-1-.32-1.55-.48-7.35-2.29-14.68-4.65-22.07-6.86C6.1 56.33 1.72 53.28 0 47.23z",
  fill: "#FFF"
});

var SvgGobelinsLogo = function SvgGobelinsLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 42.59 71.9",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGobelinsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gobelins-logo.783c5e7e.svg";
export { ForwardRef as ReactComponent };